<template>
  <div class="mbheader" :class="{color:color}">
    <div class="left" @click="$router.go(-1)" v-if="left">
      <img src="../../assets/img/arrowl.png" alt="">
    </div>
    <div class="min">{{ title }}</div>
    <div class="navbar-select" v-if="loggedIn || showCompany">
      <el-select :value="warehouseId" :placeholder="$t('pleaseSelect')" @change="changeWarehouse">
        <el-option
          v-for="item in warehouseAll"
          :key="item.id"
          :label="item.Name || item.name"
          :value="item.id"
          :disabled="company_disabled"
          >
        </el-option>
      </el-select>
    </div>
    <slot></slot>
    <div class="right" v-if="lang" @click="langChanged">
      <img src="../../assets/img/earth2.png" alt="" v-if="$route.name=='account'">
      <img src="../../assets/img/earth.png" alt="" v-else>
    </div>
  </div>
</template>

<script>
import {locales} from "../../mixin";
import {
  mapState,
  mapActions
} from 'vuex';

export default {
  name: "mbHeader",
  props: ['title', 'color', 'lang', 'left', 'showCompany'],
  mixins: [locales],
  data() {
    return {
      warehouseAll: [],
      company_disabled: false
    }
  },
  methods:{
    ...mapActions('products', ['getWarehouseByCompany','changeCompanyId','changeWarehouseId']),
    ...mapActions(['changeNavGoId','changeShowProductsType1','changeShowProductsType2','changeShowProductsType3']),
    changeWarehouse(id) {
      this.changeCompanyId(1);
      this.changeWarehouseId(id);
      if (this.$route.path === '/collections') {
        return this.$root.refreshProductsForWarehouse();
      }
      return this.changeCompany();
    },
    //更改公司重新查询
    changeCompany(){
      console.log('change公司',this.showProductsType1 ,this.showProductsType2 ,this.showProductsType3);

      if(this.showProductsType1 == 'categories'){
        //选择分组或分类
        return this.$emit('navGo',this.navGoId);
      }
      if(this.showProductsType2 == 'search'){
        //navbar搜索
        return this.$emit('searchProduct');
      }
      if(this.showProductsType3 == 'group'){
        //productList选择分组
        return this.$emit('selectNewGroup',this.navGoId);
      }
    }
  },
  computed: {
      ...mapState({
        loggedIn: state => state.auth.loggedIn,
        companyId: state => state.products.companyId,
        warehouseId: state => state.products.warehouseId,
        userInfo: state => state.auth.userInfo,
        navGoId: state => state.navGoId,
        showProductsType1: state => state.showProductsType1,
        showProductsType2: state => state.showProductsType2,
        showProductsType3: state => state.showProductsType3,
      }),
  },
  created() {
    this.getWarehouseByCompany(1)
      .then(res => {
        this.warehouseAll = res.data;
        const selected = (this.companyId === 1 && this.warehouseAll.find(item => item.id === this.warehouseId)) ||
          this.warehouseAll.find(item => item.is_default || item.IsDefault) || this.warehouseAll[0];
        if (!selected) return;
        this.changeCompanyId(1);
        this.changeWarehouseId(selected.id);
      }).catch(err => {
        console.log('err warehouses', err);
      });
  },
  watch: {
    loggedIn: function(newVal, oldVal) {
      immediate: true;
      if (oldVal === true && newVal === false) {
        
      } else if (oldVal === false && newVal === true) {
        
      }
    },
    userInfo: function(newVal, oldVal) {
      immediate: true;
      if(newVal){
        //是否可以修改公司
        this.company_disabled=true;
        if(this.userInfo.is_all_company){
          this.company_disabled=false;
        }
      }
    },

  }
}
</script>

<style scoped lang="less">
.mbheader {
  width: 100%;
  height: 50px;
  background-color: #131e1e;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 2px 16px 0;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;

  &.color {
    background-color: #FFFFFF;

    .min {
      color: black;
    }
  }

  .left, .right {
    height: 30px;
    padding: 5px;
    position: relative;
    z-index: 2;

    img {
      height: 100%;
    }
  }

  .right {
    // margin-left: auto;
  }

  .min {
    color: #FFFFFF;
    text-align: center;
    // position: absolute;
    // left: 0;
    // right: 90px;
    // margin: auto;
    // z-index: 1;
  }

  .navbar-select{
    width: 150px;
  }

  .search-bar {
    position: relative;
    margin-right: 10px;
    flex: 1;

    input {
      width: 100%;
      height: 30px;
      background-color: #FFFFFF;
      border-radius: 15px;
      color: #7cc26a;
      border: none;
      font-size: 12px;
      font-weight: bold;
      box-shadow: none;
      padding: 2px 10px 0;
      font-family: 'Source Sans Pro';
      outline: none;
    }

    .hoverBtn {
      height: 22px;
      width: 22px;
      border-radius: 15px;
      display: flex;
      justify-content: center;
      align-items: center;
      position: absolute;
      right: 5px;
      top: 50%;
      transform: translateY(-50%);
      background-color: #7cc26a;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/mobile/mbHeader.vue